import ProjectItem from '../ProjectItem/ProjectItem';

const ProjectsCatalog = ({ projects }) => {
  return (
    <ul className="projects__list">
      {projects?.map((project) => (
        <ProjectItem
          key={project.id}
          project={project.catalog}
          projectId={project.id}
          type={project.type}
          useContainedMedia={project.template === 'project-01'}
        />
      ))}
    </ul>
  );
};

export default ProjectsCatalog;
